module.exports = __webpack_public_path__ + "img/Libyan Arab Jamahiriya.cce40be3.svg";